import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
// api
import { useQueryTransactionRecordAllowedQuery } from "src/api";
// routes
import { paths } from "src/routes/paths";
// components
import { LoadingScreen } from "src/components/loading-screen";

// ----------------------------------------------------------------------

export default function TransactionHistoryGuard({ children }) {
    const { data: allowed, isFetching } = useQueryTransactionRecordAllowedQuery(undefined, {
        refetchOnMountOrArgChange: true
    });

    if (isFetching) {
        return <LoadingScreen/>;
    }

    if (!allowed) {
        return <Navigate to={ paths.dashboard.settings.profile.root } replace/>;
    }

    return children;
}

TransactionHistoryGuard.propTypes = {
    children: PropTypes.node
};
